import React from "react";
import { Stack, Typography } from "@mui/material";
import ActivityLevelIndicator from "@/components/common/activity-level-indicator/activity-level-indicator";

interface ActivityLevelProps {
  activityLevelNumber: number;
  activityLevelTitle: string;
  testIdPrefix?: string;
}

const ActivityLevel = ({
  activityLevelNumber,
  activityLevelTitle,
  testIdPrefix = ""
}: ActivityLevelProps) => (
  <Stack
    sx={{
      gap: { xs: "0.4rem", sm: "0.8rem", lg: "0.4rem" },
      flexDirection: { xs: "column-reverse", sm: "row-reverse", lg: "column" },
      alignItems: { xs: "flex-end", lg: "flex-start" }
    }}
  >
    <ActivityLevelIndicator activityLevelNumber={activityLevelNumber} size="small" testIdPrefix={testIdPrefix} />
    <Typography
      component="span"
      sx={{ fontSize: "1.8rem", textBoxTrim: "trim-both" }}
      data-testid={`${testIdPrefix}_activity-level-title`}
    >
      {activityLevelTitle}
    </Typography>
  </Stack>
);

export default ActivityLevel;
